import React from "react";
import PropTypes from "prop-types";
import { QAHeader } from "components/QualityAssurance";
import { SchedulingAssistantHeader } from "components/CallCenter";
import { MHeader } from "components/Shared";
import { userHasRight } from "selectors/rights";
import { CASE_FORMS_MAINTENANCE } from "typeConstants/rights";
import { connect } from "react-redux";

const Header = ({ pathname, history, pathkey }) => {

  switch (pathkey) {
    case "bizops-case-view":
      return (<QAHeader history={history} />);
    case "scheduling-assistant-case-view":
      return (<SchedulingAssistantHeader history={history} />);
    default:
      return (<MHeader pathname={pathname} />);
  }
};

const mapStateToProps = state => ({
  canEditCaseForms: userHasRight(CASE_FORMS_MAINTENANCE)(state),
});

Header.propTypes = {
  pathname: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  pathkey: PropTypes.string.isRequired,
  canEditCaseForms: PropTypes.bool,
};

export default connect(mapStateToProps, null)(Header);
